module.exports = __webpack_public_path__ + "img/tree-tops.a605f66e.jpg";